import React from 'react';
import './TeacherCreateClass.css'
import StartCeate from '../StartCeate/StartCeate';
import ResourceGuide from '../ResourceGuide/ResourceGuide';

function TeacherCreateClass({userId, name}) {

  return (
    <div className='teacher-create-class'>
        <h2 className='teacher-create-hello'>Hello Teacher! {name}</h2>
        <div className='teacher-create-class-split'>
            <StartCeate teacherId= {userId}/>
            <ResourceGuide />
        </div>
    </div>
  )
}

export default TeacherCreateClass